import {ACCESS_TOKEN} from '@app/common/constants';
import {revokeLogin} from '@app/utils/util';

export const resetPassword = (userToken: any) => {
  revokeLogin(userToken);
  localStorage.removeItem(ACCESS_TOKEN);
};

export const saveAccessToken = (token: string) => {
  localStorage.setItem(ACCESS_TOKEN, token);
};

export const getAccessToken = () => {
  return localStorage.getItem(ACCESS_TOKEN);
};


export const saveMsalAccount = (account: string) => {
  localStorage.setItem('MSAL_ACCOUNT', account);
};

export const getMsalAccount = () => {
  const account = localStorage.getItem('MSAL_ACCOUNT');
  return account ? JSON.parse(account) : null;
};

export const getAuthType = (): 'MSAL' | 'ONELOGIN' | null => {
  return localStorage.getItem('AUTH_TYPE') as 'MSAL' | 'ONELOGIN' | null;
};

export const setAuthType = (authType: string) => {
  localStorage.setItem('AUTH_TYPE', authType);
};